export const EShapeActionValueGestureType = wcardinal.ui.EShapeActionValueGestureType;